<template>
  <div>
    <div v-if="visualSchedule.staticRevealer" v-html="visualSchedule.staticRevealer"></div>
    <div v-else class="position-relative" id="imageRevealer">
      <div
        v-if="showCounter"
        style="top: 0; right: 0; z-index: 98"
        class="bg-success text-white p-2 rounded position-absolute font-weight-bold"
      >
        {{ subtaskLimit - completed === 0 ? 'Great job!' : subtaskLimit - completed }}
      </div>
      <div class="revealer w-100 h-100">
        <div
          v-for="index in 100"
          :key="`reveal_cover_${index}`"
          :data-index="index"
          :data-row="rowNumber(index)"
          :data-col="colNumber(index)"
          class="revealer-block"
          ref="blocks"
          :style="revealBlockStyle(index)"
        ></div>
      </div>
      <b-img :src="image" center rounded fluid></b-img>
    </div>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import { mapGetters, mapMutations, mapState } from 'vuex';
import axios from 'axios';
import { EventBus } from '../../event-bus';

export default {
  data() {
    return {
      image: null,
      subtaskLimit: 10,
      completed: 0,
      nextStartingIndex: 1,
      lastHiddenIndex: null,
      revealIncrementValues: [1, 10, -1, -10],
      incrementValIndex: 0,
      rightLimit: 9,
      downLimit: 9,
      leftLimit: 0,
      upLimit: 1,
      position: 1,
    };
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.getNextImage();
    EventBus.$on('completed-count', this.increment);
    EventBus.$on('subtask-count', this.onSubtaskCount);
    EventBus.$on('subtask-next', this.next);
    EventBus.$on('subtask-reset', this.reset);
  },

  watch: {
    // If there's a change to the visual schedule, we should reset
    visualSchedule() {
      if (!this.visualSchedule.staticContent) this.reset();
    },
  },

  destroyed() {
    EventBus.$off('completed-count', this.increment);
    EventBus.$off('subtask-count', this.onSubtaskCount);
    EventBus.$off('subtask-next', this.next);
    EventBus.$off('subtask-reset', this.reset);
  },

  computed: {
    ...mapState(['visualSchedule', 'visualScheduleChannel', 'userId']),
    ...mapGetters(['scheduleCards', 'isVisualScheduleOwner']),

    imageForPosition() {
      return this.visualSchedule.visual_schedule_reveal_images_attributes.find((img) => img.position === this.position);
    },

    incrementVal() {
      return this.revealIncrementValues[this.incrementValIndex];
    },

    revealBlocksCount() {
      return Math.floor(100 / this.subtaskLimit);
    },

    showCounter() {
      return this.visualSchedule.patient_can_see_subtask_count;
    },
  },

  methods: {
    increment(val) {
      this.completed = val;
      this.removeBlocks();
      // if (this.isVisualScheduleOwner && this.visualScheduleChannel) {
      //   this.visualScheduleChannel.send({
      //     type: 'increment_revealer',
      //     value: this.completed,
      //     id: this.userId,
      //   });
      // }
    },

    next() {
      if (this.position === this.visualSchedule.visual_schedule_cards_attributes.length) {
        this.position = 1;
      } else this.position += 1;
      this.$refs.blocks.forEach((b) => b.classList.remove('hidden'));
      this.nextStartingIndex = 1;
      this.lastHiddenIndex = null;
      this.incrementValIndex = 0;
      this.rightLimit = 9;
      this.downLimit = 9;
      this.leftLimit = 0;
      this.upLimit = 1;
      this.completed = 0;
      setTimeout(this.getNextImage, 400);
    },

    onSubtaskCount(val) {
      this.subtaskLimit = val;
    },

    reset() {
      this.$refs.blocks.forEach((b) => b.classList.remove('hidden'));
      this.nextStartingIndex = 1;
      this.lastHiddenIndex = null;
      this.incrementValIndex = 0;
      this.rightLimit = 9;
      this.downLimit = 9;
      this.leftLimit = 0;
      this.upLimit = 1;
      this.completed = 0;
      this.position = 1;
      setTimeout(this.getNextImage, 400);
    },

    getNextImage() {
      if (this.imageForPosition) {
        this.image = this.imageForPosition.image;
      } else {
        axios.get('/api/v2/reveal-images?random=1').then((response) => {
          this.image = response.data[0].image;
        });
      }
    },

    // Goes around edges to remove orange blocks in groups based on settings
    removeBlocks() {
      if (this.completed < this.subtaskLimit) {
        let i = 1;
        while (i <= this.revealBlocksCount && i < 100) {
          const newTargetObject = document.querySelector(`[data-index='${this.nextStartingIndex}']`);
          if (!newTargetObject.classList.contains('hidden')) {
            const { col, row } = newTargetObject.dataset;
            if (this.incrementVal == 1 && col == this.rightLimit) {
              this.incrementValIndex = 1;
              this.rightLimit -= 1;
            } else if (this.incrementVal == 10 && row == this.downLimit) {
              this.incrementValIndex = 2;
              this.downLimit -= 1;
            } else if (this.incrementVal == -1 && col == this.leftLimit) {
              this.incrementValIndex = 3;
              this.leftLimit += 1;
            } else if (this.incrementVal == -10 && row == this.upLimit) {
              this.incrementValIndex = 0;
              this.upLimit += 1;
            }
            newTargetObject.classList.add('hidden');
            this.nextStartingIndex += this.incrementVal;
            i += 1;
          }
        }
      } else {
        const visibleBlocks = this.$refs.blocks.filter((b) => !b.classList.contains('hidden'));
        visibleBlocks.forEach((b) => b.classList.add('hidden'));
      }
    },

    rowNumber(i) {
      return Math.floor((i - 1) / 10);
    },

    colNumber(i) {
      return Math.floor((i - 1) % 10);
    },

    revealBlockStyle(i) {
      return {
        '--top': `${this.rowNumber(i) * 10}%`,
        '--left': `${this.colNumber(i) * 10}%`,
      };
    },
  },
};
</script>

<style lang="scss">
.revealer {
  & > .revealer-block {
    top: var(--top);
    left: var(--left);
  }
}
</style>
